export default __webpack_public_path__ + "static/media/ESFJ.5e1e4ec2.svg";